import { render, staticRenderFns } from "./BusinessSubmenu.vue?vue&type=template&id=3402282a&"
import script from "./BusinessSubmenu.vue?vue&type=script&lang=js&"
export * from "./BusinessSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports